import HubspotLogo from "@app/analytics/assets/integrations/hubspot_48x48.png";
import NotionLogo from "@app/analytics/assets/integrations/notion_48x48.png";
import SalesforceLogo from "@app/analytics/assets/integrations/salesforce_48x48.png";

export const ZAP_TEMPLATES = [
  {
    app: "HubSpot",
    appLogo: HubspotLogo,
    title:
      "Create or update HubSpot contacts from new Read AI meeting participants",
    href: "https://zapier.com/app/editor/template/1547068",
  },
  {
    app: "Salesforce",
    appLogo: SalesforceLogo,
    title: "Update Salesforce contacts from new Read AI meeting participants",
    href: "https://zapier.com/app/editor/template/1547074",
  },
  {
    app: "Notion",
    appLogo: NotionLogo,
    title: "Send new Read AI meeting notes to Notion",
    href: "https://zapier.com/app/editor/template/1548731",
  },
];
